export const optionMapping = {
  'metrics-panel': 'metrics-panel',
  'dimensions-panel': 'dimensions-panel',
  'viewer-sessions': 'dimensions-panel',
  'impacted-viewers': 'dimensions-panel',
  'user-sessions': 'dimensions-panel',
  'network-request': 'dimensions-panel',
  'network-request-rca': 'dimensions-panel',
  'compare-panel': 'compare-panel',
  annotations: 'annotations',
  'alerts-panel': 'alerts-panel',
  'summary-panel': 'summary-panel',
  base: 'base',
};

export const optionNameMapping = {
  'metrics-panel': 'Metrics',
  'dimensions-panel': 'Dimensions',
  'viewer-sessions': 'Sessions',
  'impacted-viewers': 'Viewers',
  'user-sessions': 'Users',
  'network-request': 'Network Request',
  'network-request-rca': 'Network Request',
  'compare-panel': 'Compare Filters',
  annotations: 'Annotations',
  'alerts-panel': 'Alert',
  'summary-panel': 'Summary',
};

export const sectionDisplayOrder = [
  'base',
  'summary-panel',
  'compare-panel',
  'alerts-panel',
  'metrics-panel',
  'dimensions-panel',
  'annotations',
];

export const hiddenOptions = ['base'];
